import { collection, addDoc, getDocs, query, where, orderBy, limit, Timestamp } from 'firebase/firestore';
import { db } from '@/config/firebase';
import { COLLECTIONS } from '../collections';
import { AnalysisRecord } from '../types';
import { CopyAnalysisResult } from '@/types/copyAnalysis';
import { handleDatabaseError } from '@/lib/utils/errors/handlers';

export async function saveAnalysis(
  userId: string, 
  url: string, 
  analysis: CopyAnalysisResult
): Promise<string> {
  try {
    const analysesRef = collection(db, COLLECTIONS.ANALYSES);
    
    const analysisData: Omit<AnalysisRecord, 'id'> = {
      userId,
      url,
      issues: analysis.issues,
      timestamp: analysis.timestamp,
      createdAt: Timestamp.now()
    };

    const docRef = await addDoc(analysesRef, analysisData);
    return docRef.id;
  } catch (error) {
    throw handleDatabaseError(error);
  }
}

export async function getUserAnalyses(userId: string): Promise<AnalysisRecord[]> {
  try {
    const analysesRef = collection(db, COLLECTIONS.ANALYSES);
    
    const q = query(
      analysesRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc'),
      limit(10)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      return [];
    }
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as AnalysisRecord[];
  } catch (error) {
    throw handleDatabaseError(error);
  }
}